import React, { useState } from 'react';
import axios from 'axios';
import HomepageIntro from '../Home/HomepageIntro';
import { hasHomepageIntroContent, normalizeHomepageIntro } from '../../utils/homepageIntroUtils';

const HomepageIntroEditor = ({ intro, setIntro, onSuccess }) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setIntro((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (event) => {
    event.preventDefault();
    if (isSaving) return;

    setIsSaving(true);
    try {
      const response = await axios.put('/api/homepage-intro', {
        title: intro.title,
        time: intro.time,
        eventText: intro.eventText,
        downloadFile: intro.downloadFile,
        downloadLabel: intro.downloadLabel
      });
      const saved = normalizeHomepageIntro(response.data);
      setIntro(saved);
      onSuccess('Текст на главной сохранён', saved);
    } catch (error) {
      console.error('Error saving homepage intro:', error);
      alert(error.response?.data?.message || 'Ошибка при сохранении текста');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <form className="admin-form homepage-intro-editor" onSubmit={handleSave}>
      <p className="program-editor-hint">
        Этот блок показывается на главной над программами. Если программы отключены, на странице останется только он.
      </p>

      <div className="admin-form-grid">
        <div className="admin-field admin-field--wide">
          <label htmlFor="intro-title">Заголовок</label>
          <input
            id="intro-title"
            type="text"
            name="title"
            value={intro.title}
            onChange={handleChange}
            placeholder="Как promo-title на главной"
          />
        </div>
        <div className="admin-field">
          <label htmlFor="intro-time">Текст1</label>
          <input
            id="intro-time"
            type="text"
            name="time"
            value={intro.time}
            onChange={handleChange}
            placeholder="Текст1"
          />
        </div>
        <div className="admin-field">
          <label htmlFor="intro-event">Текст2</label>
          <input
            id="intro-event"
            type="text"
            name="eventText"
            value={intro.eventText}
            onChange={handleChange}
            placeholder="Текст2"
          />
        </div>
        <div className="admin-field admin-field--wide">
          <label htmlFor="intro-download">Имя файла для скачивания</label>
          <input
            id="intro-download"
            type="text"
            name="downloadFile"
            value={intro.downloadFile}
            onChange={handleChange}
            placeholder="polozhenie-o-konkurse.pdf"
          />
          <span className="admin-field-hint">
            Точное имя файла из <code>public/</code> (рекомендуется латиницей без пробелов, чтобы сервер точно отдал PDF/DOCX). Оставьте пустым, чтобы скрыть ссылку.
          </span>
        </div>
        <div className="admin-field admin-field--wide">
          <label htmlFor="intro-download-label">Подпись ссылки на главной</label>
          <input
            id="intro-download-label"
            type="text"
            name="downloadLabel"
            value={intro.downloadLabel}
            onChange={handleChange}
            placeholder="Положение о конкурсе"
          />
          <span className="admin-field-hint">
            Что показывать пользователю на пилюле. Если пусто — будет показано само имя файла. Можно кириллицей, любой длиной до 300 символов.
          </span>
        </div>
      </div>

      <div className="homepage-intro-preview">
        <span className="homepage-intro-preview__label">Как это выглядит на сайте</span>
        {hasHomepageIntroContent(intro) ? (
          <HomepageIntro intro={intro} />
        ) : (
          <p className="homepage-intro-preview__empty">Заполните поля, чтобы увидеть превью</p>
        )}
      </div>

      <div className="admin-form-footer">
        <button type="submit" className="admin-action-btn admin-action-btn--primary" disabled={isSaving}>
          {isSaving ? 'Сохранение...' : 'Сохранить текст'}
        </button>
      </div>
    </form>
  );
};

export default HomepageIntroEditor;
